import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { EonUiButton } from '@eon-ui/eon-ui-components-angular';
import { TranslatePipe } from '@ngx-translate/core';
import { GameThemeService } from '../../../service/game-theme.service';

@Component({
  selector: 'gandalf-confirm-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, EonUiButton, TranslatePipe],
  templateUrl: './confirm-dialog.html',
  styleUrl: './confirm-dialog.scss',
})
export class ConfirmDialogComponent {
  protected readonly data = inject(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);
  private readonly gameThemeService = inject(GameThemeService);
  protected readonly eonUiScheme = this.gameThemeService.getEonUiScheme();

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
